<app-state-section [state]="sectionState">
  <div class="wrapper">
    <form class="form-group" [formGroup]="form">
      <div>
        <div class="form-control" *ngIf="type === 'paid' ">
          <mat-label class="label">{{ "TransportationPayments.PaymentDate" | translate}}</mat-label>
          <app-date-input formControlName="paymentDate" [required]="true"></app-date-input>
        </div>

        <div class="form-control flex column" *ngIf="type === 'paid'" >
          <mat-label class="label">{{ "TransportationPayments.BankRef" | translate}}</mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" [placeholder]="'Placeholder.EnterTheValue' | translate" formControlName="bankRef" />
            <mat-error *ngIf=" form.invalid && form.get('bankRef').hasError('maxlength')">
              {{ "ErrorMessages.InValidLength" | translate: {length: 50 } }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-control flex column text-area" *ngIf="type === 'rejected'">
          <mat-label>{{ "TransportationPayments.RejectionReason" | translate }}</mat-label>
          <mat-form-field appearance="outline">
            <textarea
              class="text-area"
              matInput
              rows="4"
              cols="100"
              type="text"
              [placeholder]="'Placeholder.WriteAComment' | translate"
              formControlName="rejectionReason"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="flex buttons-container justify-space-between">
        <button class="button cancel" (click)="closeModal.emit()">{{'Buttons.Cancel' | translate}}</button>
        <button class="button save" (click)="save()" [disabled]="form.invalid">{{'Buttons.Save' | translate}}</button>
      </div>
    </form>
  </div>
</app-state-section>
